import { FormProps, AppFormTabProps } from 'components/AppFormLayout/AppFormData'

export const FormTabsData = [
	{
		tabId: 0,
		title: '',
        isHidden: false,
		appFormBlockList: [
			{
				colNumber: 1,
				title: '',
				labelWidth: 120,
				appFormItemList: [
					{
						type: 'Input',
						defaultValue: '',
						field: 'showName',
						label: '分组名称',
                        req: true,
					},
					{
						type: 'Input',
						defaultValue: '',
						field: 'sort',
                        label: '排序Code',
						req: true,
					},
				],
			},
		],
	}
] as AppFormTabProps[]

 



// WEBPACK FOOTER //
// ./src/modules/modeling/param/components/ParamGroupEditData.tsx